<div class="skills-wrapper">
  <qai-call-insight-card
    class="skills-card"
    [heading]="heading"
    [description]="description"
    [headingMode]="'large'"
    [descriptionMode]="'simple'"
    [showLink]="false"
    [legend]="legend"
    [objectiveFooterLabel]="objectiveFooterLabel()"
    [applyFadeGradientAtBottom]="skillsData().length > 5"
    (viewAllWithObjectiveCount)="onViewAllObjectives()"
  >
    <div qaiSlot="content">
      @if (skillsData().length === 0) {
        <p class="no-metrics-message">{{ noMetricsMessage }}</p>
      } @else {
        <div class="skills-segmented-bars-container">
          @for (item of displayedSkillsData(); track item.skillTitle) {
            <qai-segmented-bar-graph
              class="skills-segmented-bar"
              [label]="item.skillTitle"
              [labelBold]="true"
              [total]="100"
              [segments]="mapToSegments(item.skillProgress)"
              [ariaLabel]="generateAriaLabel(item.skillProgress)"
            ></qai-segmented-bar-graph>
          }
        </div>
      }
    </div>
  </qai-call-insight-card>

  <app-simulation-detail-list-modal
    #listModal
    [heading]="heading"
    [subheading]="modalSubheading()"
  >
    <div class="skills-segmented-bars-container">
      @for (item of skillsData(); track item.skillTitle) {
        <qai-segmented-bar-graph
          class="skills-segmented-bar"
          [label]="item.skillTitle"
          [labelBold]="true"
          [total]="100"
          [segments]="mapToSegments(item.skillProgress)"
          [ariaLabel]="generateAriaLabel(item.skillProgress)"
        ></qai-segmented-bar-graph>
      }
    </div>
  </app-simulation-detail-list-modal>
</div>
